import React, { useEffect, useRef } from 'react';
import { useRoot } from '../../hooks/useRoot.jsx';
import VideoPlayer from '../../../consumer-theater/components/video-player/video-player.jsx';
const PreviewVideo = () => {
  const { openPreviewWin, videoDetail } = useRoot();
  const VideoPlayerRef = useRef(null);
  useEffect(() => {
    if(openPreviewWin) {
      VideoPlayerRef.current.open(videoDetail, []);
    }
  }, [openPreviewWin, videoDetail]);

  // return (
  //   <Modal open={openPreviewWin} onCancel={() => setOpenPreviewWin(false)} closeIcon={<div className={style.closeBtn}></div>} width="70%" footer={false} className={style.customModalWrap} destroyOnClose={true}>
  //     <BorderBox>
  //       <video src={videoUrl} controls className={style.video}></video>
  //     </BorderBox>
  //   </Modal>
  // );
  return <VideoPlayer ref={VideoPlayerRef} />;
};

export default PreviewVideo;